import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static values = {
        delay: Number,
        url: String,
    };

    declare readonly delayValue: number;
    declare readonly urlValue: string;

    private timeoutId?: number;

    connect(): void {
        const url = this.urlValue.trim();
        if (!url) {
            return;
        }

        this.timeoutId = window.setTimeout(() => window.location.assign(url), this.delayValue);
    }

    disconnect(): void {
        if (this.timeoutId !== undefined) {
            window.clearTimeout(this.timeoutId);
        }
    }
}
